import { useGetOne } from 'react-admin';
import { useMemo } from 'react';
import extractIdFromURI from '@/utils/id';
import { composeUri } from '@/utils/compose';
import { USERS } from '@/utils/CONST';
import { User } from '@/utils/types';

interface Output {
    user: User | undefined;
    isLoading: boolean;
    // currentUserId: string | undefined;
    refetch: any;
}

const useGetUser = ({ enabled = true, userId }: { enabled?: boolean; userId: string }): Output => {
    // const { identity, isLoading: isLoadingIdentity } = useGetIdentity();

    // const userId = useMemo(() => identity?.user_id ?? '', [identity]);

    const {
        data: currentUser,
        isLoading: isLoadingUser,
        refetch,
    } = useGetOne(
        USERS,
        {
            id: composeUri(USERS, userId),
        },
        { enabled: userId !== '' && enabled },
    );

    const currentUserFinal = useMemo(
        () => (currentUser ? { ...currentUser, id: extractIdFromURI(currentUser.id) } : undefined),
        [currentUser],
    );

    return {
        user: currentUserFinal,
        isLoading: isLoadingUser,
        // userId: currentUserFinal ? (currentUserFinal.id as string) : undefined,
        refetch,
    };
};

export default useGetUser;
